import "./TextSearch.scss";

export default {
  name: "TextSearch",
  props: [],
  data: () => ({
    searchText: ""
  }),
  methods: {
    triggerSearch() {
      this.$emit("search");
    }
  }
};
